module.exports = __webpack_public_path__ + "img/slack-private-channel.4c47a116.svg";